import styled, {css} from "styled-components"
import {greys} from "@irati/ui/src/global/colors"

interface PlaceholderProps {
  type?: "regular" | "dark",
  width?: string,
  margin?: string
}

export const PlaceholderBase = css<PlaceholderProps>`
  border-radius: 4px;
  background-color: ${({type}) => (type === "dark" ? greys.mediumLight : greys.light)};
  width: ${({width}) => width || "100%"};
  margin: ${({margin}) => margin || "0 0 10px 0"};
`

const PlaceholderBar = styled.div<PlaceholderProps>`
  ${PlaceholderBase}
  height: ${({type}) => (type === "dark" ? "15px" : "8px")};
`

export const PlaceholderSquare = styled.div<PlaceholderProps>`
  ${PlaceholderBase}
  height: 100px;
`

interface PlaceholderContainerProps {
  border?: "none" | "dotted" | "regular",
  margin?: string,
  padding?: string
}

export const PlaceholderContainer = styled.div<PlaceholderContainerProps>`
  min-height: 200px;
  padding: ${({padding}) => padding || "0"};
  width: 100%;
  border-radius: 2px;
  border: 2px solid ${greys.light};
  ${({border}) => border === "none" && "border: none;"}
  ${({border}) => border === "dotted" && `border: 2px dotted ${greys.medium};`}
  ${({margin}) => margin && `margin: ${margin};`}
`

export default PlaceholderBar
export {default as PlaceholderGrid} from "./Grid"
export {default as PlaceholderButton} from "./Button"
